export enum ProductName {
  PlanFinder = 'plan-finder',
  TransactionFlow = 'transaction-flow',
  LeadPlatform = 'lead-platform',
  ConsumerFlow = 'consumer-flow',
}
